<div class="col-12 md:col-6 lg:col-3">
  <div class="card widget-feature-box {{ styleClass }}">
    <img [src]="image" alt="" />
    <h2>{{ title }}</h2>
    <span>{{ subTitle }}</span>
  </div>
</div>
